import { useState } from 'react';
import { useAppLifeCycle } from '../useAppLifeCycle';
import { bridge, useAsyncEffect } from '../../utils';

type UseOutfitBookMarkMapProps = {
  /** - api응답으로 생성한 likeMap */
  initialMap?: Record<string, boolean>;
};
export const useOutfitBookmarkMap = (params: UseOutfitBookMarkMapProps) => {
  const [bookmarkMap, setBookmarkMap] = useState<Record<string, boolean>>(params.initialMap ?? {});

  const { lifeCycle } = useAppLifeCycle();

  useAsyncEffect(async () => {
    if (lifeCycle === 'viewWillAppear') {
      const localGoodsLike = await bridge.getLocalOutfitBookmark();

      setBookmarkMap(prev => ({
        ...prev,
        ...localGoodsLike,
      }));
    }
  }, [lifeCycle]);

  useAsyncEffect(async () => {
    const localGoodsLike = await bridge.getLocalOutfitBookmark();
    setBookmarkMap(prev => ({
      ...prev,
      ...localGoodsLike,
    }));
  }, []);

  return { bookmarkMap, setBookmarkMap };
};
